import { NgModule } from '@angular/core';
import {
  ExcelExportOptionsComponent
} from '@app/pcs/shared/export-options/excel-export-options/components/excel-export-options.component';
import {
  ExcelExportOptionsFormComponent
} from '@app/pcs/shared/export-options/excel-export-options/components/excel-export-options-form.component';
import {
  PopOverExportOptionsModule
} from '@app/pcs/shared/export-options/pop-over-export-options/components/pop-over-export-options.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [
    ExcelExportOptionsFormComponent,
    ExcelExportOptionsComponent
  ],
  imports: [
    SharedModule,
    PopOverExportOptionsModule
  ],
  exports: [
    ExcelExportOptionsComponent
  ]
})
export class ExcelExportOptionsModule {

}
